import { errorValidation } from './utils';

let messagesPhone = $('#messages_phone');

/**
 * Init intlTelInput
 */
[messagesPhone].forEach(phoneInput => {
	phoneInput
		.intlTelInput({
			initialCountry: 'md',
			placeholderNumberType: 'aggressive',
			utilsScript:
				'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
			separateDialCode: true,
			preferredCountries: ['md'],
			onlyCountries: ['ro', 'ua', 'md'],
		})
		.inputmask({
			mask: 'V9999999',
			definitions: {
				V: {
					validator: '^[1-9][0-9]*$',
				},
			},
		});

	// Set the initial country code on page load
	let initialCountryCode = phoneInput.intlTelInput(
		'getSelectedCountryData'
	).dialCode;
	let countryCodeInput = phoneInput
		.closest('.input-wrapper')
		.find('.country-code');
	countryCodeInput.val(initialCountryCode);

	// On blur: validate
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
				// Save country code
				countryCodeInput.val(initialCountryCode);
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateMessagesPhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Messages
	$("form[name='messages']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'messages[name]': {
				required: true,
			},
			'messages[email]': {
				required: true,
				email: true,
			},
			'messages[phone]': {
				required: true,
				validateMessagesPhone: true,
			},
			'messages[comment]': {
				required: true,
			},
		},
		messages: {
			'messages[name]': {
				required: window.translations.required,
			},
			'messages[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'messages[phone]': {
				required: window.translations.required,
			},
			'messages[comment]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
